import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, every, map, Subject, takeUntil, tap } from 'rxjs';
import { LgvAPIService, LgvConstants, LgvUserService, NotificationService } from '../../core/core.module';
import { BusinessType } from '../../core/enums/shared';
import { GreaterThanZero } from '../../core/utility/lgv-form-validator';
import { LgvModel } from '../../data-models/longevity.model';
import { StdObj } from '../../data-models/standard-objects';
import { environment as env } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'lus-social-media-edit-modal',
    templateUrl: './social-media-edit-modal.component.html',
    styleUrls: ['./social-media-edit-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SocialMediaEditModalComponent implements OnInit, OnDestroy {

    /*
     * Note: This is intended to be used by both Companies and Agents.
     * Need to check for data.companyInfo and data.agentInfo
     */

    isLoading$ = new BehaviorSubject(false);
    onDestroy$ = new Subject();

    socialMediaFG: UntypedFormGroup;

    companyInfoParam: LgvModel.CompanyInfo = null;
    agentInfoParam: LgvModel.Agent = null;

    socialMediaList$ = new BehaviorSubject([]);

    get isCompanyMode(): boolean { return !!this.companyInfoParam; }
    get isAgentMode(): boolean { return !!this.agentInfoParam; }
    get title(): string { return 'Edit Social Media'; }
    get subtitle(): string { return this.isCompanyMode ? 'Information entered here will show up in the company footer.' : 'Information entered here will show up in your signature.'; }

    get socialMediaArray() { return this.socialMediaFG.controls["socialMediaArray"] as UntypedFormArray; }

    socialMediaOptions: StdObj.ListItem[] = LgvConstants.SocialMediaOptions();


    constructor(private fb: UntypedFormBuilder,
        private http: HttpClient,
        public lgvUserSvc: LgvUserService,
        private route: ActivatedRoute,
        public lgvApiSvc: LgvAPIService,
        private notificationSvc: NotificationService,
        public dialogRef: MatDialogRef<SocialMediaEditModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        if (this.data?.companyInfo) {
            this.companyInfoParam = this.data?.companyInfo;
        }
        if (this.data?.agentInfo) {
            this.agentInfoParam = this.data?.agentInfo;
        }

    }


    ngOnInit(): void {
        this.initializeForm();
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    initializeForm() {

        this.socialMediaFG = this.fb.group({
            socialMediaArray: this.fb.array([])
        });

        if (this.isCompanyMode && !!this.companyInfoParam?.companySocialMedia) {
            for (let sm of this.companyInfoParam?.companySocialMedia) {
                console.log('Adding SocialMedia: ' + sm.socialMediaTypeId);
                this.onAddSocialMedia(sm.socialMediaTypeId.toUpperCase(), sm.url);
            }
        }
        if (this.isAgentMode && !!this.agentInfoParam?.agentSocialMedia) {
            for (let sm of this.agentInfoParam?.agentSocialMedia) {
                console.log('Adding socialMedia: ' + sm.socialMediaTypeId);
                this.onAddSocialMedia(sm.socialMediaTypeId.toUpperCase(), sm.url);
            }
        }
        //    for (let ctrl of this.socialMediaArray.controls) {
        //        let fg = ctrl as UntypedFormGroup;
        //        let typeId = fg.controls['socialMediaTypeId'].value;
        //        console.log('TypeID: ' + typeId);
        //    }

    }

    onAddSocialMedia(typeId: string, url: string) {

        let controlIndex = this.socialMediaArray.controls.length;
        const fg = this.fb.group({
            id: [controlIndex],
            socialMediaTypeId: [typeId, [Validators.required]],
            url: [url, [Validators.required]]
        });
        this.socialMediaArray.push(fg);
    }

    removeSocialMedia(ccIndex: number) {
        this.socialMediaArray.removeAt(ccIndex);
    }

    onSubmit() {
        if (!this.socialMediaFG.valid) {
            return;
        }

        let model = {};

        if (this.isCompanyMode) {
            let companyModel = this.companyInfoParam;

            companyModel.companySocialMedia = this.socialMediaArray.getRawValue();

            this.isLoading$.next(true);

            this.lgvApiSvc.SaveCompany(companyModel).pipe(takeUntil(this.onDestroy$)).subscribe(x => {
                this.isLoading$.next(false);
                setTimeout(() => {
                    this.notificationSvc.success('Company Social Media has been saved');
                }, 500)
                this.lgvApiSvc.loadCompanies();
                this.dialogRef.close({ action: true });
            }
                , err => {
                    this.isLoading$.next(false);
                    this.notificationSvc.error("There was an error saving the company social media");
                }
            );
        } else if (this.isAgentMode) {


            this.isLoading$.next(true);
            this.isLoading$.next(true);
            let model = {
                firstName: this.agentInfoParam.firstName,
                lastName: this.agentInfoParam.lastName,
                jobTitle: this.agentInfoParam.jobTitle,
                agentSocialMedia: this.socialMediaArray.getRawValue()
            }

            let bldUrl = `${env.LgvApiBaseUrl}/users/${this.agentInfoParam.id}`;

            this.http.patch<any>(bldUrl, model).pipe(takeUntil(this.onDestroy$)).subscribe(x => {
                this.isLoading$.next(false);
                this.notificationSvc.success('Social Media has been updated');

                if (this.lgvUserSvc.IsImpersonatingAgent) {
                    this.lgvUserSvc.ImpersonateAgent(this.agentInfoParam.id, true);
                }
                else {
                    this.lgvUserSvc.LoadDBUserSS(false);
                }

                this.dialogRef.close({ action: true });
            },
                (err) => {
                    this.isLoading$.next(false);
                    this.notificationSvc.error('There was an error updating the social media');
                    console.log('Error:');
                    console.log(err);
                }
            );

        }


    }
    onCancel() {
        this.dialogRef.close({ action: false });
    }
}
